import { ApiEndpointClient } from './resource-client';
const BACKEND_FOR_FRONTEND_PREFIX = 'valuation-frontend';
export class ScriptAutomationsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, BACKEND_FOR_FRONTEND_PREFIX);
    }
    createInvoicingAutomationTask = async (scriptKey) => {
        return this.post('/backend-scripts/invoicing', {
            response: 'content-type-or-empty',
            json: { script: scriptKey },
        });
    };
    createClickUpToHubspotAutomationTask = async () => {
        return this.post('/backend-scripts/entries-transfer', {
            response: 'content-type-or-empty',
            json: {},
        });
    };
    getInvoicingAutomationTaskStatus = async ({ taskId }) => {
        return this.get('/backend-scripts/job-status', {
            response: 'content-type-or-empty',
            query: { task_id: taskId },
        });
    };
    getInvoicingAutomationTaskLogs = async ({ automationType, }) => {
        return this.get('/backend-scripts/logs', {
            response: 'content-type-or-empty',
            query: { automation_type: automationType },
        });
    };
}
